import { ASSETS_BASE_URL } from '../../../lib/constants';

type SuggestionProps = {
  display: string;
  avatar: string;
}

const Suggestions: React.FC<SuggestionProps> = (props) => {
  return (
    <div className=''>
      <div className='flex my-2'>
        <div
          className="flex flex-none w-10 h-10 rounded-full border-2 border-purple bg-no-repeat bg-center bg-cover mx-2"
          style={{
            backgroundImage: `url("${ASSETS_BASE_URL}${props
              .avatar ?? 'user-avatar/default.jpg'}")`
          }}
        ></div>
        <strong className='my-auto'>{props.display}</strong>
      </div>
      <hr className="w-full border-grey"></hr>
    </div>
  );
};

export default Suggestions;